import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/campaign-management/$campaignId")({
  beforeLoad: ({params, search}) => {
    throw redirect({to: "/campaign/$campaignId", params: {campaignId: +params.campaignId}, search, replace: true});
  },
});
